
import { Link } from "react-router-dom";
import ProfileAvatar from "../../../common/avatar/ProfileAvatar";
import { paletteFor } from "../../../common/expertise/ExpertiseTile";
import { profileFieldText } from "../../../profile/detail/common/ProfileSection";

function introPreview(intro) {
	const text = profileFieldText(intro).replace(/\s+/g, " ").trim();
	if (!text) return null;
	return text.length > 72 ? `${text.slice(0, 72)}…` : text;
}

export default function Doctor({ profile, index = 0 }) {
	const palette = paletteFor(index);
	const teaser = introPreview(profile?.intro);

	return (
		<Link
			to={`/profile/${profile.id}/`}
			className="group block h-full min-w-0 max-w-full no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cta/40 focus-visible:ring-offset-2 rounded-[16px]"
		>
			<div
				className={[
					"relative flex h-full min-h-[228px] flex-col items-center overflow-hidden rounded-[16px] border p-5 pt-6",
					"transition duration-300 ease-out",
					"group-hover:-translate-y-1 group-hover:scale-[1.01]",
					palette.tile,
					palette.border,
					palette.shadow,
				].join(" ")}
			>
				<div
					className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
					aria-hidden
				/>
				<div
					className="pointer-events-none absolute -left-6 -top-8 h-28 w-28 rounded-full bg-white/35 blur-2xl"
					aria-hidden
				/>
				<div
					className="pointer-events-none absolute -bottom-10 -right-6 h-32 w-32 rounded-full bg-white/25 blur-2xl"
					aria-hidden
				/>

				<div className="relative z-[1] mb-3 mt-1">
					<div
						className={[
							"rounded-full bg-white p-1 shadow-[0_8px_24px_rgba(39,106,166,0.18)] ring-4 ring-white/90",
							"transition duration-300 group-hover:scale-105 group-hover:shadow-[0_12px_32px_rgba(39,106,166,0.22)]",
						].join(" ")}
					>
						<div className="h-[76px] w-[76px] overflow-hidden rounded-full">
							<ProfileAvatar
								imageUrl={profile.avatar_url}
								name={profile.name}
								size="md"
								className="!h-[76px] !w-[76px]"
							/>
						</div>
					</div>
				</div>

				<p className="relative z-[1] line-clamp-2 text-center font-Vazir-800 text-[15px] leading-snug text-darkBlue">
					{profile.name}
				</p>

				{teaser ? (
					<p className="relative z-[1] mt-2 line-clamp-2 px-1 text-center font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/65">
						{teaser}
					</p>
				) : (
					<p className="relative z-[1] mt-2 font-Vazir-400 text-[12px] text-darkBlue/45">
						درمانگر همراهتیم
					</p>
				)}

				<span
					className={[
						"relative z-[1] mt-auto inline-flex items-center gap-1 rounded-full bg-white/75 px-3 py-1.5",
						"font-Vazir-600 text-[12px] text-darkBlue shadow-sm backdrop-blur-sm",
						"transition duration-300 group-hover:bg-white group-hover:text-cta",
					].join(" ")}
				>
					مشاهده پروفایل
					<span aria-hidden className="text-[11px] opacity-70">
						←
					</span>
				</span>
			</div>
		</Link>
	);
}
